import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class OuterCssClassService extends FormulateCssClassService {
    public process(): void {
        if(!this.isButton()) {
            this.addNonGroupedClass([
                'mb-8',
                'mx-2',
                'p-4',
                'rounded-xl',
                this.hasErrors() ? 'bg-error-lighter' : 'bg-white',
                this.hasErrors() ? 'text-error-darker' : ''
            ])
        }
    }
}

export default OuterCssClassService
